function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "appstore",
  transform: "translate(-46.022)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M54.786,142.76c-4.8-.028-8.764-9.819-8.764-14.8,0-8.145,6.11-9.928,8.465-9.928a9.74,9.74,0,0,1,3.194.786,7.139,7.139,0,0,0,1.824.523,5.675,5.675,0,0,0,1.308-.424,10.486,10.486,0,0,1,3.943-.953h.009a8.083,8.083,0,0,1,6.764,3.416l.493.741-.71.536a5.974,5.974,0,0,0-2.865,4.926,5.56,5.56,0,0,0,3.1,5.14c.444.267.9.543.9,1.146,0,.394-3.142,8.848-7.705,8.848a6.2,6.2,0,0,1-2.6-.632,5.276,5.276,0,0,0-2.316-.558,5.957,5.957,0,0,0-1.834.5,8.982,8.982,0,0,1-3.181.742Z",
  transform: "translate(0 -110.533)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_284",
  "data-name": "Path 284",
  d: "M261.209,0c.119,4.285-2.946,7.258-6.006,7.071C254.7,3.652,258.263,0,261.209,0Z",
  transform: "translate(-195.969)",
  fill: "#fff"
}));

var SvgAppstore = function SvgAppstore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.433,
    height: 32.227,
    viewBox: "0 0 26.433 32.227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppstore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appstore.9f0fb024.svg";
export { ForwardRef as ReactComponent };